'use strict';

var _ = require('lodash');
var SummaryTopOppSpillAggregationFactory = function SummaryTopOppSpillAggregationFactory(AbstractROMServiceAggregationFactory, RomSummaryTopOppGridService) {
  function SummaryTopOppSpillAggregation() {
    AbstractROMServiceAggregationFactory.call(this, ['rom-summary-top-opp-spill-mode', 'rom-summary-top-opp-recap-mode'], 'rom-summary-top-spill');
  }
  SummaryTopOppSpillAggregation.prototype = Object.create(AbstractROMServiceAggregationFactory.prototype);
  SummaryTopOppSpillAggregation.constructor = SummaryTopOppSpillAggregation;
  SummaryTopOppSpillAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType === targetType;
  };
  SummaryTopOppSpillAggregation.prototype.aggregate = function (data) {
    var maxlimit = _.toNumber(RomSummaryTopOppGridService.getMaxOpps());
    return _.isEmpty(data) ? data : this.topOppAggregate(data, maxlimit);
  };
  return SummaryTopOppSpillAggregation;
};
SummaryTopOppSpillAggregationFactory.$inject = ['AbstractROMServiceAggregationFactory', 'RomSummaryTopOppGridService'];
module.exports = SummaryTopOppSpillAggregationFactory;